<template>
  <a-select
    ref="selectRef"
    v-model:value="pageData.currentData"
    @change="selectOnChange"
    :placeholder="'请选择'"
  >
    <a-select-option value="" v-if="hasAll">全部</a-select-option>
    <a-select-option
      :value="item.behalf_config_id"
      :key="item.behalf_config_id"
      v-for="item in pageData.data"
      >{{ item.title }}</a-select-option
    >
  </a-select>
</template>
<script>
import { onMounted, inject, reactive, ref } from "vue";
import { $iscode } from "@/utils/app";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { getAgencyPaymentConfigList } from "@/api/system.js";

export default {
  name: "selectAgencyPaymentConfig",
  props: {
    // 是否显示 全部
    hasAll: Boolean
  },
  components: {},
  setup(props, { emit }) {
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const selectCp = reactive({
      open: false
    });
    /* 搜索 start */
    const searchCp = reactive({
      data: {
        keyword: ""
      },
      oldKeyword: ""
    });
    // 搜索提交
    const searchOnSubmit = (e) => {
      resetPageData();
      getPageData(gainParamData());
    };

    /* 搜索 end */

    /* 页面数据 start */
    let pageData = reactive({
      loading: false,
      // 当前第几页
      page: 1,
      // 每页数量，默认一页10条
      perPageCount: 100,
      // 总页数
      pageCount: 1,
      // 总条数，跟pageCount二选一就行
      total: 1,
      data: [],
      // 当前所有选中的数据，传入的也会再这里
      currentData: "",
      // 获取焦点时候的数据，防止一直焦点要请求数据
      focusData: []
    });
    // 清空数据
    const emptyPageData = () => {
      pageData.data = [];
    };
    // 重置数据
    const resetPageData = () => {
      emptyPageData();
      pageData.loading = false;
      pageData.lock = false;
      pageData.page = 1;
    };
    // 获取页面数据
    const getPageData = async (paramData = {}) => {
      if (pageData.loading) {
        return;
      }
      pageData.loading = true;
      emptyPageData();
      let result = await getAgencyPaymentConfigList(paramData)
        .then((res) => res.data)
        .catch((error) => error);
      pageData.loading = false;
      if ($iscode(result, true, false)) {
        let respData = result || {};
        let respList = respData.data || [];
        pageData.data = respList || [];
        pageData.total = respData.total || respList.length;
      }
    };

    /* 页面数据 end */
    /**
     * 获取getPageData需要的数据
     */
    const gainParamData = () => {
      // 转换搜索数据
      let searchData = {
        ...searchCp.data
      };
      // 转换分页数据
      let paginationData = {
        page: pageData.page,
        limit: pageData.perPageCount
      };
      return {
        ...searchData,
        ...paginationData
      };
    };

    onMounted(() => {
      pageData.currentData = props.modelValue || "";
      // 如果有默认选中，就带上默认id查询
      getPageData(gainParamData(pageData.currentData));
    });
    let selectRef = ref("");
    const selectOnChange = (e) => {
      emit("change", e);
      emit("update:modelValue", e);
    };

    return {
      selectCp,
      selectRef,
      // 搜索相关数据和操作
      searchCp,
      searchOnSubmit,
      // 页面相关数据和操作
      pageData
    };
  }
};
</script>
